const Bundle = ({ levelKey, bundleKey, completed, label, updateStatus, updateRoadmap, roadmap }) => {

    const toggleStatus = (e, levelKey, bundleKey, status) => {
        if (e.ctrlKey || e.metaKey) {
            updateRoadmap(levelKey, bundleKey);
            return;
        } else {
            let newStatus = status;

            if (status == 'complete') {
                newStatus = false;
            } else if (status == 'in-progress') {
                newStatus = 'complete';
            } else {
                newStatus = 'in-progress';
            }

            updateStatus(levelKey, bundleKey, newStatus);
        }
    }

    // Determine the bundle's position in the roadmap
    const roadmapIndex = roadmap?.findIndex(
        b => b.levelKey === levelKey && b.bundleKey === bundleKey
    );
    const roadmapOrder = roadmapIndex !== -1 ? roadmap[roadmapIndex]?.order : null;

    return (
        <div 
            className={`bundle ${completed == 'complete' ? 'completed' : (completed == 'in-progress' ? 'in-progress' : '')}`} 
            onClick={(e) => toggleStatus(e, levelKey, bundleKey, completed)}
        >
            <p>{label}</p>
            {roadmapOrder && (
                <span className="roadmap-order">{roadmapOrder}</span>
            )}
        </div>
    );
}


export default Bundle;
